module.exports = __webpack_public_path__ + "img/item_part_console_crocoh.9d3d6935.png";